<div class="form-field">
  <span class="form-field-label">
    {{ label }}<span *ngIf="required" class="required"> *</span>
  </span>
  <app-search-select [form]="form" [clear]="clear" (userChange)="userChange.emit($event)"
    (staffChange)="staffChange.emit($event)"></app-search-select>
</div>
<ng-container *ngIf="form.invalid && (form.dirty || form.touched)">
  <mat-error *ngIf="form.hasError('required')">{{ placeholder }}</mat-error>
</ng-container>
